import gql from 'graphql-tag'
export default gql`query sieveSizeQuery($id: Int!) {
  sieveSize(id: $id) {
    code
    size
    id
  }
}`